import SFetch from 'src/utils/sfetch'

export default {
  getBatch({ items, workflowId, ledgerId, compareLedgerId, requestRef }) {
    const itemsByType = {}

    items.forEach((item) => {
      const [id, type] = item
      itemsByType[type] ||= []
      itemsByType[type].push(id)
    })

    const url = Silverfin.Routes.render_elements_ledger_workflow_review_path(
      Silverfin.currentFirmId,
      Silverfin.currentCompanyId,
      ledgerId,
      workflowId,
      {
        reconciliation_texts: JSON.stringify(itemsByType.reconciliation_text),
        account_entries: JSON.stringify(itemsByType.account_entry),
        compare_ledger_id: compareLedgerId,
        request_ref: requestRef,
      }
    )

    return SFetch.jsonWithAlert(url)
  },
  cancelWorkflowReviewJobs({ ledgerId, workflowId, requestRef }) {
    const url = Silverfin.Routes.cancel_job_ledger_workflow_review_path(
      Silverfin.currentFirmId,
      Silverfin.currentCompanyId,
      ledgerId,
      workflowId,
      { request_ref: requestRef }
    )

    return SFetch.json(url, { method: 'DELETE' })
  },
  deleteWFReviewCompareLedgerId({ ledgerId, workflowId }) {
    const url =
      window.Silverfin.Routes.delete_wf_review_compare_ledger_id_users_path(
        window.Silverfin.currentFirmId,
        {
          company_id: window.Silverfin.currentCompanyId,
          ledger_id: ledgerId,
          workflow_id: workflowId,
        }
      )

    return SFetch.json(url, { method: 'DELETE' })
  },
  persistWFReviewCompareLedgerId({ compareLedgerId, ledgerId, workflowId }) {
    const url =
      window.Silverfin.Routes.persist_wf_review_compare_ledger_id_users_path(
        window.Silverfin.currentFirmId,
        {
          company_id: window.Silverfin.currentCompanyId,
          ledger_id: ledgerId,
          workflow_id: workflowId,
          compare_ledger_id: compareLedgerId,
        }
      )

    return SFetch.json(url, { method: 'POST' })
  },
}
